// extracted by mini-css-extract-plugin
export var centerText = "_6i-8";
export var container = "_6i-0";
export var doughnutContainer = "_6i-7";
export var legend = "_6i-a";
export var legendItemColorDisplay = "_6i-b";
export var legendItemLabel = "_6i-d";
export var legendItemValue = "_6i-c";
export var lg = "_6i-5";
export var maxWidth = "_6i-9";
export var md = "_6i-4";
export var responsive = "_6i-6";
export var sm = "_6i-3";
export var xs = "_6i-2";
export var xxs = "_6i-1";